define(function (require) {
    'use strict';

    var LE = require('app');
    var Button = require('ui/button/Button');
    var DiffUtil = require('manager-assets/js/DiffUtil');
    var template = require('manager-templates/audit-trail/auditTrailReviewChangesDialogView.tmpl');

    var AuditTrailReviewChangesDialogView = {};

    LE.module('LEManager', function (LEContent, LE, Backbone, Marionette, $, _) {
        AuditTrailReviewChangesDialogView = Marionette.Layout.extend({
            className: 'audit-trail-review-changes-container',
            template: template,
            ui: {
                diffContainer: '.review-changes-diff-container',
                copyOldValueButton: '.old-value-copy-btn',
                copyNewValueButton: '.new-value-copy-btn',
                closeButton: '.review-changes-close-btn'
            },
            uiComponents: {
               copyOldValueButton: {
                   type: Button,
                   options: {
                       el: 'view.ui.copyOldValueButton',
                       permutation: Button.PERMUTATION.LIGHT_BLUELINK
                   },
                   events: {
                       click: '_onCopyOldValueClick'
                   }
               },
               copyNewValueButton: {
                   type: Button,
                   options: {
                       el: 'view.ui.copyNewValueButton',
                       permutation: Button.PERMUTATION.LIGHT_BLUELINK
                   },
                   events: {
                       click: '_onCopyNewValueClick'
                   }
               },
               closeButton: {
                   type: Button,
                   options: {
                       el: 'view.ui.closeButton',
                       permutation: Button.PERMUTATION.BTN_PRIMARY
                   },
                   events: {
                       'click': '_onCloseClick'
                   }
               }
            },

            initialize: function (options) {
                this._bindEvents();
            },

            onRender: function () {
                var diffHtml = DiffUtil.generateDiffHtml(
                    this.model.getObjectName(),
                    this.model.getOldValue(),
                    this.model.getNewValue());
                this.ui.diffContainer.append(diffHtml);
            },

            _bindEvents: function () {
                this.listenTo(this, 'dialog:closeButtonClick', this._onCloseClick);
            },

            _onCopyOldValueClick: function () {
                this._copyToClipboard(this.model.getOldValue());
            },

            _onCopyNewValueClick: function () {
                this._copyToClipboard(this.model.getNewValue());
            },

            _copyToClipboard: function (value) {
                // create el containing data
                var el = document.createElement('textarea');
                el.style.left = '-99999px';
                el.style.position = 'absolute';
                el.style.opacity = '0';
                el.setAttribute('readonly', '');
                el.value = value;
                document.body.appendChild(el);

                // select all
                el.select();
                el.setSelectionRange(0, el.value.length);

                // copy to clipboard
                var copyIsSuccess = document.execCommand("copy");

                if (copyIsSuccess) {
                    LEContent.notifier.showSuccess({
                        content: LE.translator.translate("LEManager.auditTrail.reviewChangesDialog.copy.success")
                    });
                }

                // cleanup
                document.body.removeChild(el);
                el = null;
            },

            _onCloseClick: function () {
                LEContent.logger.debug('dialog close button clicked', 'AuditTrailReviewChangesDialogView:_onCloseClick');
                this._closeDialog();
            },

            _closeDialog: function () {
                this.trigger('auditTrailReviewChangesDialogView:closeDialog');
            }
        });
    });

    return AuditTrailReviewChangesDialogView;
});
